// use animations safely after transition
export default function (callback, triggerObject = null, { cleanUpMethod = 'kill', instant = false } = {}) {
	const metaStore = useMetaStore()

	nextTick(() => {
		if (instant) {
			callback()
			return
		} else {
			delay(metaStore.getDelay).then(() => callback())
		}
	})

	triggerObject && listenForKill(triggerObject, cleanUpMethod)
}

function listenForKill(triggerObject, cleanUpMethod) {
	onBeforeUnmount(async () => {
		// console.log('listenForKill', triggerObject, cleanUpMethod)
		await killTriggers(triggerObject, cleanUpMethod)
	})
}

export function killTriggers(triggerObject, cleanUpMethod) {
	Object.keys(triggerObject).forEach((key) => {
		if (typeof triggerObject[key] === 'object') {
			if (Array.isArray(triggerObject[key])) {
				// console.log('triggerObject[key] is array', triggerObject[key])
				triggerObject[key].forEach(item => {
					// console.log('array item', item)
					killItem(item, cleanUpMethod)
				})
			} else {
				// console.log('item is object', triggerObject[key])
				killItem(triggerObject[key], cleanUpMethod)
			}

			delete triggerObject[key]
		}

		return true
	})
}

function killItem(item, cleanUpMethod) {
	if (cleanUpMethod === 'kill') {
		// console.log('killing', item)
		item.kill()
	} else {
		// console.log('reverting', item)
		item.revert()
	}
}







const triggers = {}
let $q
export function useCssAnims(componentRootEl) {
	const metaStore = useMetaStore()
	const { gsap, ScrollTrigger } = useGsap()

	delay(metaStore.getDelay).then(() => {
		nextTick(() => {
			nextTick(() => {
				$q = gsap.utils.selector(componentRootEl)

				animTitleExpand()
				staggerReveal()
				parallaxImg()

				ScrollTrigger.refresh(true)
			})
		})
	})

	if (triggers) listenForKill(triggers)
}

function animTitleExpand() {
	const { gsap } = useGsap()
	const titles = $q('.so-expand')

	titles.forEach((title, i) => {
		triggers['titleExpand' + i] = gsap.timeline({
			scrollTrigger: {
				id: 'titleExpand-' + i,
				trigger: title,
				start: 'top 90%',
			},
		}).to(title, {
			'--font-width': 400,
			duration: 3,
			ease: 'expo.out'
		})
	})
}

function staggerReveal() {
	const { gsap } = useGsap()
	const elements = $q('.so-reveal')

	elements.forEach((el, i) => {
		triggers['staggerReveal' + i] = gsap
			.timeline({
				scrollTrigger: {
					id: `staggerReveal-${i}`,
					trigger: el,
					start: 'top 90%',
				}
			})
			.from(el, {
				autoAlpha: 0,
				y: 50,
				duration: 1.5,
				stagger: 0.15,
				// delay: () => (i * 0.12),
				ease: 'expo.out'
			})
	})
}

function parallaxImg() {
	const { gsap } = useGsap()
	// refactor this to look for so-move-speed attributes 
	const containers = $q('.so-paraimg')

	containers.forEach((container, i) => {
		const containerHeight = container.getBoundingClientRect().height
		const img = container.querySelector('img')
		const imgHeight = img.getBoundingClientRect().height
		const toMove = imgHeight - containerHeight

		triggers['parallaxImg-' + i] = gsap.timeline({
			scrollTrigger: {
				id: 'parallaxImg-' + i,
				trigger: img,
				start: 'top 90%',
				end: 'bottom top',
				scrub: true,
			},
		})
			.fromTo(img, {
				y: 0,
			}, {
				y: toMove * -1,
			})
	})
}